import {IFranchise, IUser} from "common_assets/types/Types";
import {ORG_ID, PreferenceConstants} from "common_assets/URL";

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    [key: string]: any;
  }
}


let instance: Storage | null = null;

/*
 * This class provide interface for
 * using localstorage and session storage
 * API's
 *
 * @export
 * @class CLStorage
 */
export default class CLStorage {
  // @ts-ignore
  public storage: Storage;

  /**
   * Creates an instance of CLStorage.
   * @param {string} [storage='localStorage']
   * @memberof CLStorage
   */
  constructor(storageType: string = "localStorage") {

    if (this.storageAvailable(storageType)) {
      if (instance == null) {
        instance = window.localStorage;
        this.storage = instance;
      } else {
        this.storage = instance;
      }
    } else {
    }
  }

  /**
   * Store key value properties
   *
   * @param {string} key
   * @param {Object} value
   * @memberof CLStorage
   */
  public write(key: string, value: any) {
    try {
      this.storage.setItem(key, JSON.stringify(value));
    } catch (ex) {
    }
  }

  /**
   * Store key value properties
   *
   * @param {string} key
   * @param {string} value
   * @memberof CLStorage
   */
  public writeString(key: string, value: string) {
    try {
      this.storage.setItem(key, value);
    } catch (ex) {
    }
  }

  /**
   * Get stored value with key
   *
   * @param {string} key
   * @memberof CLStorage
   */
  public load(key: string): any {
    try {
      return this.storage.getItem(key);
    } catch (ex) {
    }
  }

  /**
   * Remove stored item with key
   *
   * @param {string} key
   * @memberof CLStorage
   */
  public remove(key: string) {
    try {
      this.storage.removeItem(key);
    } catch (ex) {
    }
  }

  /**
   * Clear local storage
   *
   * @memberof CLStorage
   */
  public removeAll() {
    try {
      this.storage.clear();
    } catch (ex) {
    }
  }

  public storageAvailable(type: string) {
    try {
      const storage = window[type];
      const x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === "QuotaExceededError" ||
          // Firefox
          e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
        // acknowledge QuotaExceededError only if there's something already stored
        this.storage.length !== 0
      );
    }
  }
}

export const getUserObject = (): IUser | null => {
  const storage = new CLStorage();
  const userObj = JSON.parse(storage.load(PreferenceConstants.USER_INFO)) as IUser;
  if (userObj) {
    return userObj;
  }
  return null;
};
export const getSetOrgId = (): string => {
  const storage = new CLStorage();
  let params = new URLSearchParams(window.location.search)
  let org = storage.load(PreferenceConstants.ORG_ID);
  if(params.get("org")){
    org = params.get("org");
  }
  if (!org) {
    org = ORG_ID;
  }
  storage.writeString(PreferenceConstants.ORG_ID, org);
  return org;
};
export const getSelectedFranchise = (): IFranchise | null => {
  const storage = new CLStorage();
  const fr = JSON.parse(storage.load(PreferenceConstants.SELECTED_FRANCHISE)) as IFranchise;
  if (fr) {
    return fr;
  }
  return null;
};
export const getCurrentFranchiseGST = (): number => {
  const storage = new CLStorage();
  const fr = getUserObject();
  const currentFranchise = currentFranchiseId();
  if (fr) {
      let t = fr.Franchise.find(e=>e.Id = currentFranchise);
      if(t) {
        return t.GstPercentage || 0;
      }
  }
  return 0;
};
export const getUserCPT = (): string | null => {
  const storage = new CLStorage();
  const cpt = storage.load(PreferenceConstants.CPT);
  if (cpt) {
    return cpt;
  }
  return null;
};


export const currentFranchiseId = () =>  window.FRANCHISE ? window.FRANCHISE.Id : ""